import { post } from 'api/post';
import { put } from 'api/put';
import { get } from 'api/get';
import { reqDelete } from 'api/req-delete';

import _ from 'lodash';

import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

export const ROI_SAVE_DATA_SUCCESS = 'roi/save/success';
export const ROI_SAVE_DATA_FAILURE = 'roi/save/failure';

export const ROI_GET_DATA_REQUEST = 'roi/get/request';
export const ROI_GET_DATA_SUCCESS = 'roi/get/success';
export const ROI_GET_DATA_FAILURE = 'roi/get/failure';

export const ROI_UPDATE_DATA_SUCCESS = 'roi/update/success';
export const ROI_UPDATE_DATA_FAILURE = 'roi/update/failure';

export const ROI_GET_DETAILS_SUCCESS = 'roi/get-details/success';
export const ROI_GET_ALL_DETAILS_SUCCESS = 'roi/get-all-details/success';
export const ROI_GET_DETAILS_FAILURE = 'roi/get-details/failure';

export const ROI_CLEAR_DETAILS = 'roi/details/clear';

export const ROI_DELETE_SUCCESS = 'roi/delete/success';
export const ROI_DELETE_FAILURE = 'roi/delete/failure';

export const ROI_CREATE_PROSPECT_VENDOR_REQUEST = 'roi/create-prospect-vendor/request';
export const ROI_CREATE_PROSPECT_VENDOR_SUCCESS = 'roi/create-prospect-vendor/success';
export const ROI_CREATE_PROSPECT_VENDOR_FAILURE = 'roi/create-prospect-vendor/failure';

export function getROIData() {
  return async (dispatch) => {
    dispatch({
      type: ROI_GET_DATA_REQUEST,
      payload: null
    });

    try {
      const req = await get('vendors/modeling');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: ROI_GET_DATA_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_GET_DATA_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function clearCalcDetails() {
  return {
    type: ROI_CLEAR_DETAILS,
    payload: null
  };
}

export function getCalcDetails(calcID) {
  return async (dispatch) => {
    try {
      const req = await get('vendors/modeling/details/' + calcID);
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: ROI_GET_DETAILS_SUCCESS,
        payload: data
      });
    } catch (error) {
      const err = buildErrorPayload(error);

      dispatch({
        type: ROI_GET_DETAILS_FAILURE,
        payload: err
      });

      if (err.code === 404) {
        dispatch(appendStatus('Calculation not found.', 'error'));
      } else {
        dispatch(appendStatus(err.errorMessage, 'error'));
      }
    }
  };
}

export function getALLCalcDetails(calcIDs) {
  return async (dispatch) => {
    try {
      const response = await Promise.all(
        calcIDs.map((calcID) => {
          return get('vendors/modeling/details/' + calcID);
        })
      );
      const data = response.map((resp) => _.get(resp, 'data.payload', []));

      dispatch({
        type: ROI_GET_ALL_DETAILS_SUCCESS,
        payload: data
      });
    } catch (error) {
      const err = buildErrorPayload(error);
      dispatch({
        type: ROI_GET_DETAILS_FAILURE,
        payload: err
      });

      if (err.code === 404) {
        dispatch(appendStatus('Calculation not found.', 'error'));
      } else {
        dispatch(appendStatus(err.errorMessage, 'error'));
      }
    }
  };
}

function locValueToFloat(data) {
  data.SA && (data.SA = parseFloat(data.SA));
  if (typeof data?.WineryOnline != 'undefined') {
    data.WineryOnline = parseFloat(data.WineryOnline || 0);
  }
  data.EU && (data.EU = parseFloat(data.EU));
  data.US && (data.US = parseFloat(data.US));
  data.UK && (data.UK = parseFloat(data.UK));
  data.APAC && (data.APAC = parseFloat(data.APAC));

  return data;
}

function cleanData(data) {
  let cleanedData = _.cloneDeep(data);

  for (let i = 0; i < cleanedData.items.length; i++) {
    delete cleanedData.items[i].calcs;

    cleanedData.items[i].domestic = parseFloat(cleanedData.items[i].domestic);
    cleanedData.items[i].estimatedDTC_SA = parseFloat(cleanedData.items[i].estimatedDTC_SA);
    cleanedData.items[i].fob = parseFloat(cleanedData.items[i].fob);
    cleanedData.items[i].international = parseFloat(cleanedData.items[i].international);
    cleanedData.items[i].production = parseFloat(cleanedData.items[i].production);
    cleanedData.items[i].wineryCD = parseFloat(cleanedData.items[i].wineryCD);
    cleanedData.items[i].srp = locValueToFloat(cleanedData.items[i].srp);
  }

  cleanedData.calcVars.dtcProjectedMarketShare = locValueToFloat(cleanedData.calcVars.dtcProjectedMarketShare);
  cleanedData.calcVars.networkFeeWarehouseManagement = locValueToFloat(
    cleanedData.calcVars.networkFeeWarehouseManagement
  );
  cleanedData.calcVars.transactionPercentageByLocation = locValueToFloat(
    cleanedData.calcVars.transactionPercentageByLocation
  );

  cleanedData.calcVars.networkFeeFreightMovement.SA = locValueToFloat(
    cleanedData.calcVars.networkFeeFreightMovement.SA
  );
  cleanedData.calcVars.networkFeeFreightMovement.EU = locValueToFloat(
    cleanedData.calcVars.networkFeeFreightMovement.EU
  );
  cleanedData.calcVars.networkFeeFreightMovement.US = locValueToFloat(
    cleanedData.calcVars.networkFeeFreightMovement.US
  );
  cleanedData.calcVars.networkFeeFreightMovement.UK = locValueToFloat(
    cleanedData.calcVars.networkFeeFreightMovement.UK
  );
  cleanedData.calcVars.networkFeeFreightMovement.APAC = locValueToFloat(
    cleanedData.calcVars.networkFeeFreightMovement.APAC
  );

  cleanedData.calcVars.vatVars = locValueToFloat(cleanedData.calcVars.vatVars);

  cleanedData.calcVars.vatOffset = locValueToFloat(cleanedData.calcVars.vatOffset);

  Object.entries(cleanedData.calcVars.percentageRatesByTier).forEach(function (key) {
    key[1].SA = parseFloat(key[1].SA);
    key[1].EU = parseFloat(key[1].EU);
    key[1].UK = parseFloat(key[1].UK);
    key[1].US = parseFloat(key[1].US);
    key[1].APAC = parseFloat(key[1].APAC);
  });

  return cleanedData;
}

export function saveROIData(data) {
  return async (dispatch) => {
    try {
      // Remove the calcs from the list
      const cleanedData = cleanData(data);

      const req = await post('vendors/modeling', cleanedData);
      const resp = _.get(req, 'data.payload', null);

      dispatch({
        type: ROI_SAVE_DATA_SUCCESS,
        payload: {}
      });

      dispatch(appendStatus('Calculation saved successfully.', 'info'));

      return resp;
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_SAVE_DATA_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function updateROIData(data) {
  return async (dispatch) => {
    try {
      const cleanedData = cleanData(data);
      await put('vendors/modeling', cleanedData);

      dispatch({
        type: ROI_UPDATE_DATA_SUCCESS,
        payload: {}
      });

      dispatch(appendStatus('Calculation updated successfully.', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_UPDATE_DATA_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function deleteROIData(id) {
  return async (dispatch) => {
    try {
      await reqDelete('vendors/modeling', {
        id: id
      });

      dispatch({
        type: ROI_DELETE_SUCCESS,
        payload: null
      });

      dispatch(appendStatus('Calculation deleted successfully.', 'info'));
      dispatch(getROIData());
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_DELETE_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function createProspectVendor(name, roiModelingSource) {
  return async (dispatch) => {
    dispatch({
      type: ROI_CREATE_PROSPECT_VENDOR_REQUEST,
      payload: null
    });

    try {
      const resp = await post('vendors/modeling/vendor', {
        name: name,
        roiModelingSource: roiModelingSource
      });

      const payload = _.get(resp, 'data.payload', null);

      dispatch({
        type: ROI_CREATE_PROSPECT_VENDOR_SUCCESS,
        payload: payload
      });

      dispatch(appendStatus('Prospect supplier created successfully.', 'info'));

      return payload;
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_CREATE_PROSPECT_VENDOR_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));

      return false;
    }
  };
}
